import { Base } from "ui/Scripts/source/framework/base";
import { EventTypeNode, IEventTypeNode } from "./eventTypeNode";

export interface IEventTypeNodes {
    items: IEventTypeNode[];
}

export class EventTypeNodes implements IEventTypeNodes {
    items: EventTypeNode[];

    constructor();
    constructor(obj: IEventTypeNode);
    constructor(obj?: any) {
        this.items = Base.getTypedArray(obj.items, EventTypeNode);
    }
}